import { BundleItem, Release } from "../types";

/**
 * Converts a BundleItem to a Release object for use with ReleaseCard
 */
export function bundleItemToRelease(item: BundleItem): Release {
  return {
    id: item.release_id,
    entity_type: "Release" as const,
    image_url: item.comic_image_url,
    image_small_url: item.comic_image_small_url,
    thumbnail_url: item.thumbnail_url,
    localized_name: item.release_title,
    localized_comic_name: item.comic_name,
    title: item.release_title,
    url: item.read_url,
    read_url: item.read_url,
    share_url: item.read_url,
    lang_display: "",
    lang_id: item.release_lang_id,
    comic_id: item.comic_id,
    total_pageviews: item.release_total_pageviews,
    total_comments: 0,
    page_count: item.release_page_count,
    update_time: item.release_published_time,
    description: "",
    reactions: [],
    page_objects: [],
    has_next_release: false,
    has_previous_release: false,
    is_vertical_format: false,
    is_free: item.release_force_is_free === 1,
    is_nsfw: item.release_is_nsfw === 1,
    comic_facets: [],
    chapter: parseInt(item.release_chapter) || 0,
    chapter_type: item.release_chapter_type,
    time_ago: "",
    is_augmented: item.release_is_augmented === 1,
    augment_blur: 0,
    background_color: "",
    next_release_read_url: "",
    previous_release_read_url: "",
    pdf_download_sale_available: false,
    next_release_order: 0,
    key: item.release_uuid,
    order: item.release_order,
    price: {
      entity_type: "Price",
      id: 0,
      price_type_id: 0,
      currency_id: 0,
      price_int: item.ppb_price_point,
      allow_variable_max_price: 0,
      price_int_discounted: null,
      display_price: `$${(item.ppb_price_point / 100).toFixed(2)}`,
      price_float: item.ppb_price_point / 100,
      is_for_sale: !item.user_owns_release,
      is_on_sale: false,
      is_discounted: false,
      price_full_int: item.ppb_price_point,
      price_full_float: item.ppb_price_point / 100,
    },
    ppb_price_point: item.ppb_price_point,
    premium_only: true,
    release_user_purchase: item.user_owns_release
      ? {
          entity_type: "ReleaseUserPurchase",
          id: 0,
          token: "",
          release_id: item.release_id,
          user_id: 0,
          session_id: 0,
          net_price: "0",
          is_downloadable: 0,
          is_active: 1,
          context_entity_type_id: null,
          context_entity_id: null,
          creator_id: 0,
          updater_id: 0,
          update_time: new Date(),
          create_time: new Date(),
          download_url: "",
          can_moderate: false,
        }
      : null,
    access_token_download: null,
    tracked_website_url: "",
    paid_access_thumbnail_blur: false,
    can_edit: false,
    edit_url: "",
    is_open: false,
    user_read_status: {
      comic_id: item.comic_id,
      last_page_read: 0,
      last_read_date: "",
      is_complete: false,
      count_read_completed: 0,
      count_read: 0,
      count_pages_read: 0,
      lang_id: item.release_lang_id,
      order: item.release_order,
      read_progress_percentage: 0,
      uuid: item.release_uuid,
    },
    artist: {
      entity_type: "Artist" as const,
      id: item.artist_id,
      name: item.artist_name,
      creator_user_id: 0,
      website: "",
      description: "",
      lang: "",
      avatar_image_id: item.artist_avatar_image_id || 0,
      banner_image_id: null,
      roman_name: item.artist_roman_name,
      twitter: "",
      facebook: "",
      accepted_date: "",
      total_favorites: 0,
      total_news: 0,
      total_projects: 0,
      total_releases: 0,
      business_name: null,
      ga_id: "",
      artist_type_id: 0,
      last_activity: "",
      total_posts: 0,
      country_id: "",
      monthly_donation_goal: "",
      monthly_donation_amount: 0,
      accept_donations: 0,
      user_is_supporter: false,
      user_is_following: false,
      artist_actions: [],
      artist_type: {
        entity_type: "",
        id: 0,
        display_order: 0,
        name: "",
        plural_name: "",
        slug: "",
        description: null,
        is_active: 0,
      },
      type_display: "",
      lang_display: "",
      url: item.artist_url,
      country_display: "",
      donate_url: "",
      secure_donate_url: "",
      edit_url: "",
      delete_url: "",
      admin_edit_url: "",
      income_url: "",
      incentive_codes_url: "",
      add_fan_url: "",
      avatar_url: item.artist_avatar_url || "",
      avatar_small_url: item.artist_avatar_url || "",
      avatar_tiny_url: item.artist_avatar_url || "",
      banner_url: "",
      flag_url: "",
      twitter_url: "",
      website_url: "",
      website_display: "",
      share_url: "",
      facebook_display: "",
      can_edit: false,
      gold_details: null,
      bundles: [],
    },
  };
}